<template>
    <div class="relative" v-click-outside="close">
        <button @click.prevent="toggle" class="btn w-10 h-10 p-0 px-0 hover:ring-red-500/50">
            <svg class="w-4 h-4 text-red-500" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16">
                <path
                    d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                <path
                    d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
            </svg>
        </button>
        <div v-if="isOpened"
             class="translate-y-2 absolute z-30 w-64 whitespace-nowrap card card-white border border-gray-300 dark:border-slate-500 right-0 top-full p-2">
            <div class="font-medium p-2">Не видеть</div>
            <div class="text-sm flex flex-col">
                <label @click="toggleBlock('posts')"
                       class="block cursor-pointer p-2 rounded hover:bg-gray-50 dark:hover:bg-slate-700 flex space-x-2 items-center">
                    <div class="rounded border w-5 h-5 border-gray-300 bg-white flex items-center justify-center">
                        <svg v-if="blockData.posts" class="text-red-500 h-5 h-5" xmlns="http://www.w3.org/2000/svg"
                             width="16" height="16"
                             fill="currentColor" viewBox="0 0 16 16">
                            <path
                                d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                        </svg>
                    </div>
                    <div>Посты подсайта</div>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
    props: [
        'block',
        'channelid',
    ],
    data() {
        return {
            blockData: this.block || false,
            isOpened: false,
        };
    },
    methods: {
        toggle() {
            this.isOpened = !this.isOpened;
        },
        close() {
            this.isOpened = false;
        },
        toggleBlock(type) {
            let newValue = !this.blockData[type];
            let data = {};
            data[type] = newValue;
            Client.post('/api/v1.1/channel/' + this.channelid + '/block', data)
                .then(response => {
                    this.blockData = response.data.block;
                    if (newValue) {
                        notify({
                            type: 'success',
                            text: 'Теперь вы НЕ будете видеть посты из этого подсайта',
                        });
                    } else {
                        notify({
                            type: 'success',
                            text: 'Теперь вы будете видеть посты из этого подсайта',
                        });
                    }
                })
                .catch(error => {
                    notify({
                        type: 'error',
                        text: 'Что-то пошло не так',
                    });
                });
        },
    },
    computed: {
        isBlocked() {
            return this.blockData.posts;
        }
    }
}
</script>